import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';
import { SalesCommissionReportHdrToGendocHdrLinkContainerModel } from '../../../../../models/aggregates/sales-commission/sales-commission-report-hdr-gendoc-hdr-link-container.model';

@Injectable({
    providedIn: 'root'
})
export class SalesCommissionReportHdrGenDocHdrLinkeService extends BaseApiTemplateService<SalesCommissionReportHdrToGendocHdrLinkContainerModel> {

    //https://api.akaun.cloud/core2/tnt/dm/fi/sale-commission-cycle/backoffice-ep

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + "sales-commission-report-gen-doc-hdr-link/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + "sales-commission-report-gen-doc-hdr-link/backoffice-ep";
        this.httpClient = http;
      }
}